module.exports = __webpack_public_path__ + "first-200-ir.jpg?cda77587fd12508f89a6647e0be7f172";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/first-200-ir.jpg
// module id = 472
// module chunks = 0